import * as API_CONSTANT from "../constants";

export const getInfoByUser = (uid) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/user/get/uid`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({
      uid,
    }),
  }).then((res) => res.json());

export const getRoleByUser = (uroleid) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/user/getRole`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({
      uroleid,
    }),
  }).then((res) => res.json());

export const getUserHierarchy = (hierCode) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/user/getHierarchy`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({
      hierCode,
    }),
  }).then((res) => res.json());

export const updateUserInfo = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/user/update`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());
